"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Tencent is pleased to support the open source community by making SPA UI available.
 * Copyright (C) 2021, a Tencent company. All rights reserved
 */
exports["default"] = {
  componentName: 'odc-pro-dialog-body',
  componentVersion: '0.0.1',
  name: 'odc-pro-dialog-body',
  version: '0.0.1'
};